export default __webpack_public_path__ + "eda9d811e96e8d1bd1cffbb74d9ba84d.png";